<template>
  <div class="Process">
    <my_title :content="title" ></my_title>
    <time_line :process="process"></time_line>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import Timeline from '@/components/frontpage/Timeline.vue';
 export default {
   name: 'Process',
   props: ['process'],
   computed: {
     title () {
       return '赛事流程'
     }
   },
   components: {
     my_title: MyTitle,
     time_line: Timeline
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Process{
   /* background-image: url(~@/assets/image/frontpage/bg-process.png); */
   background-image: url('/oss/images/frontpage/bg-process.png');
   background-size: 100vw;
   width: 100vw;

   height: 29.17vw;
   display: flex;
   box-sizing: border-box;
   padding: 4.5vw;
   flex-direction: column;
   justify-content: space-between;
   align-items:center;
 }
</style>
